import { forwardRef, useEffect, useImperativeHandle, useState } from "react";

import { Alert, Button, Select } from 'antd';
import { Method_POST } from "../../../../../../../service/api";
import { toast } from "react-toastify";
import { Box, CircularProgress } from "@mui/material";


const AtribuirAnalista = forwardRef(({ setIsModalAtribuirContador, numeroSolicita, fetchData, visibleBtn }, ref) => {

  const [listAnalista, setListAnalista] = useState([]);
  const [analistaAtribuido, setAnalistaAtribuido] = useState("");
  const [loading, setLoading] = useState("");

  useEffect(() => {
    fetchAnalista();
  }, [])


  const fetchAnalista = async () => {
    setLoading(true);
    try {
      const url = `/ordem-servico/analista/listar`;
      const data = { situacao: { id: "A" } }; // aqui eu seto o situacao/id com o valor de "A" (código original está do mesmo jeito);

      const response = await Method_POST(url, data);

      if (Array.isArray(response)) {
        setListAnalista(response);
      } else {
        console.log("Formato inesperado de resposta:", response);
        setListAnalista([]);
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error.message);
      setListAnalista([]);
    } finally {
      setLoading(false);
    }
  };

  const atribuirAnalista = async () => {
    setLoading(true);
    if (!analistaAtribuido) {
      toast.error("Nenhum analista selecionado.");
      return;
    }

    //console.log("Atribuído!");


    try {
      const url = `/ordem-servico/analista/atualizar`;
      const data = {
        id: numeroSolicita,
        usuarioAtribuicao: {
          id: analistaAtribuido,
        },
      };

      const response = await Method_POST(url, data);

      if (response) {
        toast.success("Atribuição feita com sucesso!");
        //console.log("dados:", response);
        fetchData();
        setIsModalAtribuirContador(false);
        return true;
      }
    } catch (error) {
      toast.error("ERROR - ", error.message);
      console.error("Erro ao atribuir analista:", error.message);
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => ({
    atribuirAnalista,
  }));

  return (

    <>
      <div style={{padding: 5}}>
        {loading ? (
          <>
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          </>
        ) : (
          <>
            <div style={{ marginBottom: 15 }}>
              <p>Analista</p>
              <Select
                style={{ width: "100%" }}
                showSearch
                value={analistaAtribuido || undefined}
                placeholder="Selecione um analista"
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                onChange={(value) => setAnalistaAtribuido(value)}
                options={listAnalista.map((analista) => ({
                  value: analista.id,
                  label: analista.nome,
                }))}
              />
            </div>
          </>
        )}

        {visibleBtn ? (
          null
        ) : (
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <div>
              <Button style={{ margin: "0 10px" }} onClick={() => setIsModalAtribuirContador(false)}>
                Fechar
              </Button>
            </div>
            <div>
              <Button onClick={atribuirAnalista}>
                Salvar
              </Button>
            </div>
          </div>
        )}
      </div>
    </>
  );
});
export default AtribuirAnalista;
